import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";

const Engagements = () => {
  const navigate = useNavigate();

  // Seminar images for the slideshow
  const seminarImages = [
    "/images/slideshow/1.jpg",
    "/images/slideshow/2.jpg",
    "/images/slideshow/3.jpg",
    "/images/slideshow/4.jpg",
    "/images/slideshow/5.jpg",
    "/images/slideshow/6.jpg",
    "/images/slideshow/7.jpg",
    "/images/slideshow/8.jpg",
    "/images/slideshow/9.jpg",
    "/images/slideshow/10.jpg"
  ];

  // Responsive settings for the carousel
  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  return (
    <div className="container py-5" style={{margin:"auto"}}>
      <h1 className="text-center mb-5 heading">Engage with us</h1>

      {/* Text Section */}
      <div className="mb-5" style={{ textAlign: "justify" }}>
        <p>
          At <strong>The Civil Lab</strong>, we specialize in providing hands-on training
          and real-world exposure to students and professionals in the field of
          civil engineering. Over the past decade, we have partnered with numerous
          colleges and companies to conduct impactful seminars and training programs.
        </p>
        <p>
          Our seminars and training sessions are designed to cover essential topics such as 
          surveying, non-destructive testing, material testing, site engineering, 
          and project drafting. These sessions include interactive demonstrations and 
          hands-on exercises using state-of-the-art equipment, ensuring a dynamic 
          and engaging learning experience for participants.
        </p>
        <p>
          Students from across India, including states like Bihar, Madhya Pradesh, 
          and West Bengal, have participated in our programs and benefited immensely. 
          Many of them are now excelling in both government and private sectors, 
          leveraging the skills gained through our comprehensive training.
        </p>
        <p>
          Whether you are a student looking to join our <strong>training programs</strong>, a college 
          interested in hosting a <strong>seminar</strong>, or a company aiming to upskill your 
          team through <strong>corporate training</strong>, we have tailored solutions for you.
        </p>
        <p>
          To connect with us, fill out our <strong>contact form</strong> or email us directly 
          at <a href="mailto:info@thecivillab.com">info@thecivillab.com</a>. We’ll get 
          back to you to discuss how we can collaborate and meet your training needs.
        </p>
        <div className="text-center mt-4">
          <button
            className="btn btn-primary"
            onClick={() =>
              navigate("/contact?enquiryType=college-enquiry")
            }
          >
            Get in Touch
          </button>
        </div>
      </div>

      {/* Slideshow Section */}
      <div className="seminar-slideshow mb-5">
        <h2 className="text-center mb-4">Seminar Highlights</h2>
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3000}
          arrows={true}
          showDots={true}
          containerClass="carousel-container"
        >
          {seminarImages.map((image, index) => (
            <div key={index} >
             <center>
                <img
                src={image}
                alt={`Seminar ${index + 1}`}
                style={{
                  width: "auto",
                  height: "600px",
                  borderRadius: "8px",
                }}
                />
              </center> 
            </div>
          ))}
        </Carousel>
      </div>

      {/* Why Partner Section */}
      <div style={{ textAlign: "justify" }}>
        <h2 className="text-center mb-4">Why Partner with Us?</h2>
        <p>
          - We offer customized training programs tailored to the unique needs of 
          colleges, companies, and individuals.
        </p>
        <p>
          - Our experienced trainers have worked on real projects and bring
          first-hand knowledge of civil engineering tools and practices.
        </p>
        <p>
          - Flexible training options conducted either on-campus or at our 
          fully-equipped institute, providing convenience and quality.
        </p>
        <p>
          - Proven track record of training thousands of participants, many of whom 
          have secured prestigious roles in government and private sectors.
        </p>
        <p>
          Engage with <strong>The Civil Lab</strong> today to bring industry-relevant training to your 
          students or employees, ensuring their success in the competitive world of civil 
          engineering.
        </p>
      </div>
    </div>
  );
};

export default Engagements;
